export const startTypingEffect = ({
  chatId,
  messageId,
  fullText,
  setChats,
  setCurrentMessages,
  onComplete,
  stopRef,
}) => {
  let index = 0;
  let rafId = null;

  const updater = chatId ? setChats : setCurrentMessages;
  const length = fullText.length;

  const MIN_CHUNK = 8;
  const MAX_CHUNK = 60;

  const step = () => {
    if (stopRef?.current) return;

    const remaining = length - index;
    const chunk = Math.min(
      MAX_CHUNK,
      Math.max(MIN_CHUNK, Math.ceil(remaining / 12))
    );

    index += chunk;

    updater((prev) =>
      chatId
        ? prev.map((chat) =>
            chat.id === chatId
              ? {
                  ...chat,
                  messages: chat.messages.map((m) =>
                    m.id === messageId
                      ? { ...m, text: fullText.slice(0, index) }
                      : m
                  ),
                }
              : chat
          )
        : prev.map((m) =>
            m.id === messageId ? { ...m, text: fullText.slice(0, index) } : m
          )
    );

    if (index < length) {
      rafId = requestAnimationFrame(step);
    } else {
      onComplete?.();
    }
  };

  step();

  return () => {
    if (rafId) cancelAnimationFrame(rafId);
  };
};
